import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import AuthRoutes from './routes/AuthRoutes.jsx';
import UserRoutes from './routes/UserRoutes.jsx';
import AdminRoutes from './routes/AdminRoutes.jsx';
import PublicCourseDetails from './pages/public/PublicCourseDetails.jsx';
import PublicPostDetails from './pages/public/PublicPostDetails.jsx';
import PublicSurveyFill from './pages/public/PublicSurveyFill.jsx';
import { NotificationProvider } from './context/NotificationContext';
import { PermissionsProvider, usePermissions } from './context/PermissionsContext.js';

import './tailwind.css';
import './App.css';
import './tailwind.css';

function AppRouter() {
  const { permissions } = usePermissions()

  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const navigate = useNavigate();
  const initialLoadRef = useRef(true);

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    if (initialLoadRef.current && token && (currentPath === '/' || currentPath === '/auth/login')) {
      initialLoadRef.current = false;
      if (role === 'trainee') {
        navigate('/user/dashboard', { replace: true });
      } else {
        let allow = permissions.dashboard_management_cards_view
          ||
          permissions.dashboard_management_graphs_view
          ||
          permissions.dashboard_management_view
          ||
          permissions.dashboard_management_view_latest_updates_view

        if (!allow) {
          navigate('/admin/courses', { replace: true });
        } else {
          navigate('/admin/dashboard', { replace: true });
        }
      }
    }
  }, [token, role, navigate, permissions]);

  return (
    <Routes>
      {/* Public routes - accessible to everyone */}
      <Route path="/public/courseDetails/:encodedId" element={<PublicCourseDetails />} />
      <Route path="/public/postDetails/:encodedId" element={<PublicPostDetails />} />
      <Route path="/survey/:slug" element={<PublicSurveyFill />} />

      {/* Auth routes - when not logged in */}
      {!token && <Route path="/*" element={<AuthRoutes />} />}

      {/* User routes - when logged in as trainee */}
      {token && role === 'trainee' && <Route path="/*" element={<UserRoutes />} />}

      {/* Admin routes - when logged in as admin/trainer */}
      {token && role !== 'trainee' && <Route path="/*" element={<AdminRoutes />} />}
    </Routes>
  );
}

function App() {
  return (
    <PermissionsProvider>
      <NotificationProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </NotificationProvider>
    </PermissionsProvider>
  );
}

export default App;
